import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { removeItem, setItem } from '../db';

function* processSignout() {
  yield setItem('token', null);
  yield removeItem('providerId');
  window.location.href = '/signin';
}

export default function* userSignoutSaga() {
  yield takeLatest(AT.USER_SIGNOUT_SAGA, processSignout);
}
